import request from '../utils/request';

//模板列表
export function gettemplateList(data) {
    return request({
        url: '/api/case_tpl_list',
        method: 'post',
        data
    });
}

//系统字段模板列表
export function getSystemTemplate(data) {
    return request({
        url: '/api/sys_tpl_field_list',
        method: 'post',
        data
    });
}

//新增模板
export function addTemplatePort(data) {
    return request({
        url: '/api/case_tpl_add',
        method: 'post',
        data
    });
}

//获取中心或客户自定义模板字段
export function getCustomTemplate(data) {
    return request({
        url: '/api/kehu_tpl_field_list',
        method: 'post',
        data
    });
}

//新增自定义字段 批量
export function addCustomFields(data) {
    return request({
        url: '/api/zidingyi_field_add_two',
        method: 'post',
        data
    });
}

//删除自定义字段
export function deleteCustomFields(data) {
    return request({
        url: '/api/zidingyi_field_del',
        method: 'post',
        data
    });
}

//预览模板
export function previewTemplate(data) {
    return request({
        url: '/api/case_tpl_scan',
        method: 'post',
        data
    });
}

//删除模板
export function deleteTemplate(data) {
    return request({
        url: '/api/case_tpl_del',
        method: 'post',
        data
    });
}
